export const addThousandsSeparator = (str: number | string) => {
  str = str.toString()
  let output = ''
  let counter = 0
  for (let i = str.length - 1; i > -1; i--) {
    output = str[i] + output
    counter++
    if (counter === 3 && i !== 0) {
      output = '٬' + output
      counter = 0
    }
  }
  return output
}
